<template>
    <div class="main">
        <comHeader :active="12" :value="value" style="background-color: rgba(156, 187, 107, 1); border: none">
            <template #dovlogo>
                <img src="@/assets/img/ChatLibrary-logo.png" alt="" />
            </template>
        </comHeader>
        <div class="main_body">
            <div class="main_top">
                <div class="main_sear">
                    <div class="sea_tit">
                        <div class="sea_txt">
                            ChatData <br />
                            {{ $t('chatdata.title') }}
                        </div>
                    </div>
                    <p class="txt_tit">
                        {{ $t('chatdata.introduce') }}
                    </p>
                    <div class="enterbtn" style=" text-align: left;margin:  20px 0 0 10px;">
                        <button @click="tohome"> {{ $t('chatdata.start') }}</button>
                    </div>
                </div>
                <img class="img_ai" src="../../assets/img/home_img/u167.png" alt="" />
            </div>
        </div>
        <div class="banner" v-loading="loading" style="">
            <div class="center" style="padding: 30px 0 0 0; min-height: calc(100vh - 340px)">
                <!-- <div class="enterbtn">
          <button @click="tohome">开始体验</button>
        </div> -->
                <div class="box_">
                    <div class="box_right">
                        <img style="width: 100%; border-radius: 20px" src="../../assets/video/chatdata表格解析工具.gif" alt="" />
                    </div>
                    <div class="box_left">
                        <p class="txt_p">
                            {{ $t('chatdata.introduceOne') }}
                        </p>
                    </div>
                </div>

                <!-- <div class="warp_bottom">
            <el-carousel
              indicator-position="outside"
              autoplay
              :interval="8000"
              :loop="true"
            >
              <el-carousel-item v-for="item in swiperList" :key="item.id">
                <div class="bottom_info">
                  <div class="bottom_detail">
                    <div style="font-size: 30px; margin-bottom: 10px">
                      {{ item.tit }}
                    </div>
                    <div>{{ item.info }}</div>
                    <div>{{ item.detail }}</div>
                  </div>
                  <div>
                    <img :src="item.img" />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <img class="bac_img" src="@/assets/img/u11.png" width="683px" />
          </div> -->
                <el-dialog :title="$t('chatdata.hint')" :visible.sync="centerDialogVisible" :width="'700px'" center class="steer__"
                    :close-on-click-modal="false">
                    <div class="answer_css_">
                        <!-- <p style="color: #000000;line-height: 30px;font-weight: 600;font-size: 18px;">
                            ChatData
                        </p> -->
                        <p style="font-size: 16px;">{{$t('chatdata.hintOne')}}~</p>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button style="letter-spacing: 3px; font-weight: 600" size="small" type="primary"
                            @click="close_click" round>{{$t('chatdata.Isee')}}</el-button>
                    </span>
                </el-dialog>
            </div>
            <ComFooter></ComFooter>
        </div>
    </div>
</template> 
     
<script>
import comHeader from "@/components/ComHeader.vue";
import ComFooter from "@/components/ComFooter_one.vue";
export default {
    components: {
        comHeader,
        ComFooter,
    },
    data() {
        return {
            fileList: [],
            leftList: [],
            loading: false,
            swiperList: [
                {
                    id: 1,
                    tit: "解析多个文件",
                    info: "支持创建会话，",
                    detail: "对多个文件进行解析并提问。",
                    img: require("@/assets/img/u15.png"),
                },
                {
                    id: 2,
                    tit: "解析图表",
                    info: "支持对图表进行解析并提问，",
                    detail: "辅助科研工作高效开展。",
                    img: require("@/assets/img/u14.png"),
                },
                {
                    id: 3,
                    tit: "解析多个文件",
                    info: "支持创建会话，",
                    detail: "对多个文件进行解析并提问。",
                    img: require("@/assets/img/u15.png"),
                },
                {
                    id: 4,
                    tit: "解析图表",
                    info: "支持对图表进行解析并提问，",
                    detail: "辅助科研工作高效开展。",
                    img: require("@/assets/img/u14.png"),
                },
            ],
            value: "ChatDocuments",
            video_index: 0,
            centerDialogVisible: true,

            video_show: true,
        };
    },
    created() {
        if (localStorage.getItem("leftList")) {
            this.leftList = JSON.parse(localStorage.getItem("leftList"));
        }

        // this.playVideo();

        // this.initial()
        // setTimeout(() => {
        //   this.$nextTick(() => {
        //     const playButton = this.$refs.playButton;
        //     playButton.click();
        //   });
        // }, 10000);
    },
    mounted() {
        // 在组件挂载后（初始化后），自动触发播放按钮的点击事件
    },
    methods: {
        close_click(){
            this.centerDialogVisible = false
        },
        initial() {

            this.video_index = 0;
            this.route();
            this.playVideo();
        },
        route() {
            this.video_show = false;
            this.$nextTick(() => {
                this.video_show = true;
            });
        },
        playVideo() {
            //   this.$refs.videoPlayer.play();
            const video = this.$refs.videoPlayer;
            video.play().catch((error) => {
                // 捕捉播放失败的错误
                console.error("播放失败：", error);
            });
        },
        tohome() {
            this.centerDialogVisible = true
            // this.$router.push({ path: "/uploadData" });
        },
        reHref(e) {
            window.open(e);
        },
        handlePreview(file) {
            var file = file.raw;
            // this.fileList.push(file.raw);
            var form = new FormData();
            form.append("file", file);
            this.loading = true;
            this.$api.pdfupload.pdfupload(form).then((res) => {
                this.pdf_id = res.data.data.pdf_md5;
                this.loading = false;
                this.$api.pdfupload.pdfhref({ pdf_id: this.pdf_id }).then((res) => {
                    this.pdf_url = res.data.data.pdf_url;
                    this.leftList.push({
                        pdf_id: this.pdf_id,
                        name: file.name,
                        url: this.pdf_url,
                        createtime: "2023-04-26 18:06:18",
                        pdf_state: res.data.data.pdf_state,
                    });
                    localStorage.setItem("leftList", JSON.stringify(this.leftList));
                    this.$message.success(this.$t('chatdocument.uploadSuccess'));
                    this.$router.push({ path: "/home", query: { pdf_id: this.pdf_id } });
                });
            });
        },

    },
};
</script>
    
<style lang="less" scoped>
.main {
    width: 100%;
    min-height: 100vh;
}

.main_body {
    // padding: 20px;
    //   margin: 20px;
    //   margin-top: 0;
    //   height: 300px;
    //   padding: 30px 0;

    background-color: rgba(156, 187, 107, 1);
}

.main_top {
    width: 80%;
    max-width: 1100px;
    //   width: 1100px;
    margin: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;

    .img_ai {
        // width: 520px;
        width: 745px;
    }
}

.main_sear {
    position: absolute;
    top: 50px;
    left: 0;
    width: 700px;
    // margin: 20px 0 0 0;
}

.sea_txt {
    text-align: left;
    font-weight: 600;
    font-size: 35px;
    line-height: 45px;
    color: white;
    white-space: nowrap;
}

.txt_tit {
    text-align: left;
    line-height: 20px;
    margin: 20px 0 10px 0;
    color: white;

}

.banner {
    // background: linear-gradient(
    //   179.99999999999994deg,
    //   rgba(212, 225, 251, 1) 0%,
    //   rgba(236, 223, 232, 1) 15%,
    //   rgba(255, 255, 255, 1) 31%
    // );
}

.center {
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    //   justify-content: center;
    //   align-items: center;
}

.enterbtn {
    button {
        padding: 13px 30px;
        font-size: 16px;
        text-transform: uppercase;
        letter-spacing: 2.5px;
        font-weight: 500;
        color: #fff;
        background: linear-gradient(111.08039707992252deg,
                rgba(80, 110, 219, 1) 46%,
                rgba(89, 113, 226, 1) 46%,
                rgba(128, 128, 255, 1) 91%);
        border: none;
        border-radius: 45px;
        -webkit-box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
        -webkit-transition: all 0.3s ease 0s;
        transition: all 0.3s ease 0s;
        cursor: pointer;
        outline: none;
    }

    button:hover {
        background-color: #1677ff;
        -webkit-box-shadow: 0px 15px 20px rgba(46, 125, 229, 0.4);
        box-shadow: 0px 15px 20px rgba(46, 125, 229, 0.4);
        color: #fff;
        -webkit-transform: translateY(-7px);
        -ms-transform: translateY(-7px);
        transform: translateY(-7px);
    }

    button:active {
        -webkit-transform: translateY(-1px);
        -ms-transform: translateY(-1px);
        transform: translateY(-1px);
    }
}

@media screen and (max-width: 1400px) {
    .bottom_info {
        display: flex;
        align-items: center;

        .bottom_detail {
            margin-right: 60px;
            text-align: left;
            line-height: 30px;
            font-size: 16px;
            width: 380px !important;
            padding-left: 45px !important;
        }

        img {
            width: 580px !important;
            height: 345px !important;
        }
    }

    .bac_img {
        width: 600px !important;
        right: 122px !important;
    }
}

.warp_bottom {
    width: 1150px;
    margin: 40px auto;
    margin-top: 80px;
    display: flex;
    // background: #eee;
    // justify-content: center;
    // padding: 0 40px;
    // padding-bottom: 20px;
    position: relative;

    /deep/ .el-carousel--horizontal {
        width: 1150px;
        height: 434px;
    }

    /deep/ .el-carousel__container {
        height: 395px;
    }

    /deep/ .el-carousel__arrow {
        background-color: rgba(31, 45, 61, 0);
        color: transparent;
    }

    /deep/ .el-carousel__item.is-animating {
        transition: transform 5s ease-in-out;
    }

    /deep/ .el-carousel__indicators--outside {
        display: none;
    }

    // background: #797979;
    .bottom_info {
        display: flex;
        align-items: center;

        .bottom_detail {
            margin-right: 50px;
            text-align: left;
            line-height: 30px;
            font-size: 16px;
            width: 389px;
            padding-left: 15px;
        }

        img {
            width: 660px;
            height: 380px;
        }
    }

    .bac_img {
        position: absolute;
        top: -10px;
        right: 30px;
        z-index: 10;
    }

    .enter_left {
        width: 40%;
        padding-left: 50px;

        h2 {
            font-size: 24px;
            margin: 10px 0;
        }

        p {
            font-size: 18px;
            margin: 5px 0;
        }

        p:nth-child(3) {
            margin-bottom: 70px;
        }
    }
}

.box_ {
    display: flex;
    align-items: center;
    margin: 30px 20px;

    .box_left {
        max-width: 400px;
        margin: auto;

        // position: relative;
        // left: 50px;
        .txt_p {
            width: 280px;
            font-size: 17px;
            text-align: left;
            line-height: 35px;
            font-weight: 600;
            display: block;
            border-radius: 30px;
        }

        .txt_p:hover {
            cursor: pointer;
            background: rgba(213, 240, 252, 0.5);
        }
    }

    .box_right {
        width: 700px;
        // margin: auto;

        .video_ {
            //   width: 85%;
            height: 350px;
            background: #f1f1f1;
            border-radius: 20px;
        }
    }
}

.dot_css {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.6s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;

}

/deep/ .el-dialog {
    border-radius: 20px;
}
</style>